/* eslint-disable-for-generated-file */
/**
 * Generated by orval
 * Do not edit manually.
 * Fireknife API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
    MutationFunction,
    UseMutationOptions,
    UseMutationResult,
} from '@tanstack/react-query';

import type { APIErrorResponseResponse, AddPictureBodyBody, UploadFile200 } from '.././model';

import { customInstance } from '.././custom-axios-instance';

/**
 * @summary Add new file
 */
export const uploadFile = (addPictureBodyBody: AddPictureBodyBody, signal?: AbortSignal) => {
    const formData = new FormData();
    formData.append(`file`, addPictureBodyBody.file);

    return customInstance<UploadFile200>({
        url: `/files/upload`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
        signal,
    });
};

export const getUploadFileMutationOptions = <
    TError = APIErrorResponseResponse,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof uploadFile>>,
        TError,
        { data: AddPictureBodyBody },
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof uploadFile>>,
    TError,
    { data: AddPictureBodyBody },
    TContext
> => {
    const mutationKey = ['uploadFile'];
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof uploadFile>>,
        { data: AddPictureBodyBody }
    > = (props) => {
        const { data } = props ?? {};

        return uploadFile(data);
    };

    return { mutationFn, ...mutationOptions };
};

export type UploadFileMutationResult = NonNullable<Awaited<ReturnType<typeof uploadFile>>>;
export type UploadFileMutationBody = AddPictureBodyBody;
export type UploadFileMutationError = APIErrorResponseResponse;

/**
 * @summary Add new file
 */
export const useUploadFile = <TError = APIErrorResponseResponse, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof uploadFile>>,
        TError,
        { data: AddPictureBodyBody },
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof uploadFile>>,
    TError,
    { data: AddPictureBodyBody },
    TContext
> => {
    const mutationOptions = getUploadFileMutationOptions(options);

    return useMutation(mutationOptions);
};
